import styled from "styled-components";
import { FoodSymbolIconSvg } from "@cart-ui/widgets/food-symbol-icon";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const CustomiseHeader = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "flex-start",
    margin: `${theme?.spacing?.empty} ${theme?.spacing?.medium}}`,
    padding: `${theme?.spacing?.xxLarge} ${theme?.spacing?.empty} ${theme?.spacing?.medium}`,
    borderBottom: `1px solid ${theme?.colors?.[theme?.colorMode]?.background_Button_Disabled}`,
}));

export const StyledFoodIcon = styled(FoodSymbolIconSvg)({
    marginTop: "3px",
    alignSelf: "flex-start",
});

export const CustomiseHeaderContent = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    flex: 1,
    marginLeft: theme?.spacing?.xSmall,
}));

export const CustomiseHeaderContentName = styled(Text)({
    width: "80%",
    outline: 0,
});

export const CustomiseHeaderContentPrice = styled(Text)(({ theme }) => ({
    "&:before": {
        content: "'\\20b9'",
        marginRight: "0.1rem",
    },
    marginTop: theme?.spacing?.xxxSmall,
}));

export const CustomiseActions = styled.div(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    height: "50px",
    margin: `${theme?.spacing?.large} ${theme?.spacing?.medium} calc(var(--sab, 0px) + ${theme.spacing.xLarge})`,

    "& > div": {
        width: "48%",
    },
}));
